import Marquee from "react-fast-marquee";

const words = ["Modular", "Open-Source", "Privacy-First", "Interoperable", "Sovereign", "Scalable"];

const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="glass-panel border-x-0 py-10">
    <Marquee speed={28} gradient={false} autoFill>
      {words.map((w) => (
        <span key={w} className="flex items-center">
          <span className="font-serif-editorial italic text-3xl sm:text-4xl text-ink-dim px-8">{w}</span>
          <span className="text-clay text-xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
